@layer module {
.confirmation-modal-wrapper {
            position: relative;
    }

.confirmation-modal-container {
            display: flex;
            flex-flow: column nowrap;
            align-items: center;
            justify-content: space-evenly;
    }

.confirmation-modal-content {
            width: 100%;
    }
} // layer module










@layer app {
.confirmation-modal-container {
            max-width: $size-500;
            padding: $size-20;
    }

.confirmation-modal-content {
            margin-bottom: $size-50;
    }

.confirmation-modal-content .heading {
            margin-bottom: $size-10;
    }

      @media (min-width: 480px) {
                .confirmation-modal-container {
                        padding: $size-30 $size-50 $size-40;
                    }
          }

.confirmation-modal-container {
            width: var(--modal-fill-inline-size);
            color: var(--text-primary);
            font-size: var(--font-size-lg);
            font-style: normal;
            font-weight: 400;
            line-height: $size-19;
    }

.confirmation-modal-content .heading {
            font-size: var(--font-size-xl);
            font-weight: 400;
            line-height: $size-28;
            color: var(--text-primary);
    }
} // layer app
